module.exports = BeaconAction;